import classnames from 'classnames';

export const cn = classnames;
